<template>
  <div class="paymentsPageMainLayout">
    <div class="row mr-0 ml-0 w-100 paymentsTopbar">
      <div style="margin:auto">
        <div class="d-flex justify-content-center">
          <div
            class="fiifiPaymentTitle"
            style="font-family: Comfortaa,cursive;font-weight: bold;"
          >fiifi</div>
          <div class="fiifiPaymentTitle" style="color:#CF77FF;margin-left:5px">{{planabbrivation}}</div>
        </div>
        <div>
          <div class="paymentPlanTitle">{{planText}}</div>
        </div>
      </div>
    </div>
    <div class="row mr-0 ml-0 w-100" style="margin-top:50px">
      <div style="margin:auto">
        <div
          style="margin-top:4px"
          class="userNumberdiv"
          v-if="showSlider"
        >For {{sliderValue}} users</div>
        <div style="margin-top:33px;text-align:center" v-if="showSlider">
          <div>
            <range-slider
              class="slider"
              :min="sliderMin"
              :max="sliderMax"
              step="1"
              v-model="sliderValue"
              @input="sliderChange"
            ></range-slider>
          </div>
        </div>
        <div style="margin-top:70px">
          <div class="d-flex">
            <div
              class="paymentCard"
              @click="changeSubscription('monthly')"
              :style="monthlyBackground"
            >
              <div style="margin-top:40px">
                <div class="paymentDollar" :style="monthlyMoColor">${{monthDollarValue}}</div>
                <div class="paymentMO" :style="monthlyMoColor">/mo.</div>
              </div>
              <div style="margin-top:25px">
                <div class="paymentPayMonthly" :style="monthlyMoColor">Pay Monthly</div>
              </div>
            </div>
            <div
              class="paymentCard"
              @click="changeSubscription('yearly')"
              :style="yearlyBackground"
            >
              <div style="margin-top:12px">
                <div class="paymentSaving">{{discount}}% saving</div>
              </div>
              <div style="margin-top:14px">
                <div class="paymentDollar" :style="yearlyMoColor">${{yearDollarValue}}</div>
                <div class="paymentMO" :style="yearlyMoColor">/mo.</div>
              </div>
              <div style="margin-top:25px">
                <div>
                  <div class="paymentPayMonthly" :style="yearlyMoColor">Pay Annually</div>
                </div>
                <div style="margin-top:3px">
                  <div class="paymentPayMonthly" :style="yearlyMoColor">${{yearTotalDollarValue}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:52px">
          <div>
            <div class="paymentContinueString">Price per Contributor, billed monthly</div>
          </div>
          <div style="margin-top:22px" class="d-flex justify-content-center">
            <div
              class="continueToPaymentButton d-flex justify-content-center"
              @click="createAndMountFormElement"
            >
              <div class="continueToPaymentButtonString">Continue to payment</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top
      title="Enter Payment Details"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      style="margin: 0 auto;"
      class="editCompanyPopup col-lg-12 col-sm-12 col-12 col-md-12 paymentModal"
    >
      <div class="row">
        <div class="col-12 investor-table-wrapper">
          <form @submit.prevent="createPaymentMethod">
            <div class="row">
              <div class="col-12">
                
                <div class="row">
                  <div class="col-6">
                    <div>Cardholder Name</div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="value.firstName"
                      placeholder="First name"
                    />
                  </div>
                  <div class="col-6">
                    <div>Last Name</div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="value.lastName"
                      placeholder="Last name"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>
                  Email
                  <span class="required">*</span>
                </div>
                <input
                  type="text"
                  required
                  v-model="value.email"
                  class="form-control"
                  placeholder="Email"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>
                  Card Number
                  <span class="required">*</span>
                </div>
                <div id="card-number-element" class="input-value form-control"></div>
                <!-- <input
                type="text"
                v-model="value.cardNumber"
                class="form-control"
                placeholder="Card Number"
                />-->
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div>
                  Expiration date
                  <span class="required">*</span>
                </div>
                <div id="card-expiry-element" class="input-value form-control"></div>
                <!-- <input
                type="date"
                v-model="value.expirationDate"
                class="todo-form-date todo-form form-control"
                />-->
              </div>
              <div class="col-6">
                <div>
                  CVC
                  <span class="required">*</span>
                </div>
                <div id="card-cvc-element" class="input-value form-control"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>Billing street address</div>
                <input
                  type="text"
                  v-model="value.streetAddress1"
                  class="form-control"
                  placeholder="Street address"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>Billing address 2</div>
                <input
                  type="text"
                  v-model="value.streetAddress2"
                  class="form-control"
                  placeholder="Address 2"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div>City</div>
                <input type="text" class="form-control" placeholder="City" v-model="value.city" />
              </div>
              <div class="col-3">
                <div>State</div>
                <input type="text" class="form-control" v-model="value.state" placeholder="State" />
              </div>
              <div class="col-3">
                <div>Zip</div>
                <input type="text" class="form-control" v-model="value.zip" placeholder="Zip" />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div>Promocode</div>
                <div class="d-flex promocodeMainDiv">
                  <div class="promocodeTextFieldDiv">
                    <input
                      type="text"
                      v-model="value.coupon"
                      placeholder="Enter Promocode"
                      class="promocodeInputTypeText"
                    />
                  </div>
                  <div class="applyPromocodeTextMainDiv" @click="applyPromoCode" v-if="!showLoader">
                    <div class="applyPromocodeText">Apply</div>
                  </div>
                  <div
                    class="icon-container"
                    style="top: calc(50% - 3px);right: 25px;"
                    v-if="showLoader"
                  >
                    <i class="searchloader"></i>
                  </div>
                </div>
                <div
                  class="validPromocodeStyle"
                  v-if="validPromoCode"
                >Promocode successfully applied</div>
                <div
                  class="validPromocodeStyle"
                  v-if="inValidPromoCode"
                  style="color:#E84D4D"
                >Sorry, this promo code is not valid</div>
              </div>
            </div>
            <!-- <div slot="footer" class="dialog-footer" style> -->
            <!-- <div style="border: 0.8px solid #EDEDED;opacity: 1;margin-top: 18px;"></div> -->
            <div
              class="col-xl edit-company-action-button-row"
              style="padding: 0px;margin-top: 30px;"
            >
              <button
                type="button"
                class="todo-form-cancel-button btn-outline-secondary"
                @click.prevent="handleCancel"
              >Cancel</button>
              <button
                type="submit"
                class="todo-form-submit-button btn btn-primary"
                :disabled="showSpinner || isDisabled"
              >
                Pay ${{btnAmount}}
                <b-spinner v-if="showSpinner" style="float: right;" small label="Loading..."></b-spinner>
              </button>
            </div>
          </form>
          <!-- </div> -->
          <div class="d-flex">
            <div style="height: 15px; width: 15px;margin-right:5px">
              <img
                title="Stripe"
                src="static/img/stripe.png"
                style="min-height: 100%; min-width: 100%;max-height: 100%; max-width: 100%;"
              />
            </div>
            <div style="color:#5446F3">
              <small>Integrated with Stripe</small>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import RangeSlider from "vue-range-slider";
import config from "../../../../config/settings";
import "vue-range-slider/dist/vue-range-slider.css";
import { Dialog, Select, Option } from "element-ui";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
export default {
  name: "paymentsPage",
  components: {
    RangeSlider,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      config,
      sliderValue: 1,
      planText: "",
      sliderMin: 1,
      sliderMax: 5,
      showSlider: true,
      monthDollarValue: 30,
      yearDollarValue: 27,
      yearTotalDollarValue: 324,
      plan: "",
      planSelected: "yearly",
      planToggle: 0,
      monthlyBackground: "",
      yearlyBackground: "background-color:#5446F3;margin-left:51px",
      monthlyMoColor: "",
      yearlyMoColor: "color:#fff",
      isShow: false,
      showSpinner: false,
      value: {},
      stripe: null,
      stripeValidationMsg: "",
      elements: null,
      cardForm: {},
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
      customerObj: null,
      discount: 10,
      mainMonthDollarValue: 30,
      mainYearDollarValue: 27,
      mainYearTotalDollarValue: 324,
      planId: "",
      storage: 0,
      yearlyPriceId: "",
      monthlyPriceId: "",
      email: "",
      showLoader: false,
      isDisabled: false,
      btnAmount: 0,
      validPromoCode: false,
      inValidPromoCode: false,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    planabbrivation() {
      if (this.$route.query.plan) {
        if (this.$route.query.plan == "ap") {
          this.planText = "Angel Pro";
          // this.sliderMin = 3;
          // this.sliderMax = 15;
          this.showSlider = true;
          //this.sliderValue = 3;
          //this.monthDollarValue = 30;
          //this.yearDollarValue = 27;
          //this.yearTotalDollarValue = 324;
          this.plan = "ap";
          return "AP";
        }
        if (this.$route.query.plan == "pi") {
          this.planText = "Portfolio Insider";
          // this.sliderMin = 10;
          // this.sliderMax = 25;
          this.showSlider = true;
          //this.sliderValue = 10;
          // this.monthDollarValue = 200;
          //this.yearDollarValue = 180;
          //this.yearTotalDollarValue = 2160;
          this.plan = "pi";
          return "PI";
        }
        // if (this.$route.query.plan == "im") {
        //   this.planText = "Investment Manager";
        //   this.showSlider = false;
        //   return "IM";
        // }
      } else {
        this.planText = "Angel Pro";
        //this.sliderMin = 3;
        //this.sliderMax = 15;
        this.showSlider = true;
        //this.sliderValue = 1;
        //this.monthDollarValue = 30;
        //this.yearDollarValue = 27;
        //this.yearTotalDollarValue = 324;
        this.plan = "ap";
        return "AP";
      }
    },
    // showAmount: {
    //    get() {
    //     return this.planSelected == "yearly"
    //     ? this.yearDollarValue
    //     : this.monthDollarValue;
    //   },
    //   set(value) {
    //     this.value.isShow = value;
    //     this.value.data.priority = "medium";
    //     this.$emit("input", this.value);
    //   }
    // }
  },
  mounted() {
    if (window.localStorage.getItem("plan")) {
      window.localStorage.removeItem("plan");
    }
    this.value.email = this.user.email;
    this.value.firstName = this.user.firstName;
    this.value.lastName = this.user.lastName;
    this.stripe = Stripe(this.config.STRIPE_KEY);
    this.getPlanLimits();
    // this.createAndMountFormElement();
  },
  watch: {
    $route(to, from) {
      this.getPlanLimits();
    },
  },
  methods: {
    getPlanLimits() {
      api.get(`get/plan/limits/${this.$route.query.plan}`).then((data) => {
        let resp = data.data.encrypt.success;
        this.sliderMin = resp.minLimit;
        this.sliderMax = resp.maxLimit;
        this.sliderValue = resp.minLimit;
        this.discount = resp.discount;
        this.monthDollarValue = resp.monthlyAmount;
        this.yearDollarValue = resp.yearlyAmount;
        this.yearTotalDollarValue = resp.yearlyAmount * 12;
        this.mainMonthDollarValue = resp.monthlyAmount;
        this.mainYearDollarValue = resp.yearlyAmount;
        this.mainYearTotalDollarValue = resp.yearlyAmount * 12;
        this.yearlyPriceId = resp.yearlyPriceId;
        this.monthlyPriceId = resp.monthlyPriceId;
        this.storage = resp.storage;
        this.planId = resp._id;
      });
    },
    createAndMountFormElement() {
      this.isShow = true;
      this.btnAmount =
        this.planSelected == "yearly"
          ? this.yearDollarValue
          : this.monthDollarValue;
      setTimeout(() => {
        var elements = this.stripe.elements();
        this.elements = elements;
        this.cardNumberElement = elements.create("cardNumber");
        this.cardNumberElement.mount("#card-number-element");
        this.cardExpiryElement = elements.create("cardExpiry");
        this.cardExpiryElement.mount("#card-expiry-element");
        this.cardCvcElement = elements.create("cardCvc");
        this.cardCvcElement.mount("#card-cvc-element");
        this.cardNumberElement.on("change", this.setValidationError);
        this.cardExpiryElement.on("change", this.setValidationError);
        this.cardCvcElement.on("change", this.setValidationError);
      });
    },
    setValidationError(event) {
      this.stripeValidationMsg = event.error ? event.error.message : "";
    },
    sliderChange() {
      let actualValue = this.sliderValue;
      if (this.plan == "ap") {
        this.monthDollarValue = this.mainMonthDollarValue;
        this.yearDollarValue = this.mainYearDollarValue;
        this.yearTotalDollarValue = this.mainYearTotalDollarValue;
        let sliderValue;
        if (this.sliderValue > Number(this.sliderMin)) {
          sliderValue = Number(actualValue) - Number(this.sliderMin);
          sliderValue = sliderValue * 30;
          this.calculatePlanValues(sliderValue, this.monthDollarValue);
        }
      }
      if (this.plan == "pi") {
        this.monthDollarValue = this.mainMonthDollarValue;
        this.yearDollarValue = this.mainYearDollarValue;
        this.yearTotalDollarValue = this.mainYearTotalDollarValue;
        let sliderValue;
        if (this.sliderValue > Number(this.sliderMin)) {
          sliderValue = Number(actualValue) - Number(this.sliderMin);
          sliderValue = sliderValue * 30;
          this.calculatePlanValues(sliderValue, this.monthDollarValue);
        }
      }
    },
    calculatePlanValues(sliderValue, actual) {
      this.monthDollarValue = actual + sliderValue;
      let discount = (this.monthDollarValue * Number(this.discount)) / 100;
      let yearDollarValue = this.monthDollarValue - discount;
      this.yearDollarValue = yearDollarValue;
      this.yearTotalDollarValue = yearDollarValue * 12;
    },
    changeSubscription(value) {
      this.planSelected = value;
      this.planToggle = value == "yearly" ? 0 : 1;
      if (value == "yearly") {
        this.monthlyBackground = "";
        this.yearlyBackground = "background-color:#5446F3;margin-left:51px";
        this.monthlyMoColor = "";
        this.yearlyMoColor = "color:#fff";
      } else {
        this.monthlyBackground = "background-color:#5446F3";
        this.yearlyBackground = "margin-left:51px";
        this.monthlyMoColor = "color:#fff";
        this.yearlyMoColor = "";
      }
    },
    handleCancel() {
      this.isShow = false;
      this.value = {};
      this.value.email = this.user.email;
      this.value.firstName = this.user.firstName;
      this.value.lastName = this.user.lastName;
      this.showSpinner = false;
      this.showLoader = false;
      this.isDisabled = false;
      this.inValidPromoCode = false;
      this.validPromoCode = false;
      this.value.coupon = "";
    },
    writeToServer() {
      this.showSpinner = true;
      this.handleCancel();
    },
    createPaymentMethod() {
      let self = this;
      this.showSpinner = true;
      let payload = {};
      payload.info = JSON.parse(JSON.stringify(this.value));
      payload.account_id = this.$route.params.account_id;
      payload.plan = this.planId;
      payload.type = this.planSelected;
      payload.planSelected = this.planSelected;
      payload.priceId =
        this.planSelected == "yearly"
          ? this.yearlyPriceId
          : this.monthlyPriceId;
      payload.quantity = this.sliderValue;
      payload.storage = this.storage;
      payload.amount = this.btnAmount;
      return this.stripe
        .createPaymentMethod({
          type: "card",
          card: this.cardNumberElement,
        })
        .then((result) => {
          if (result.error) {
            self.showSpinner = false;
            this.$toaster.error(result.error.message);
          } else {
            self.createSubscription({
              paymentMethodId: result.paymentMethod.id,
              priceId: payload.priceId,
              data: payload,
            });
          }
        });
    },
    createSubscription({ paymentMethodId, priceId, data }) {
      let self = this;
      let payload = {
        paymentMethodId,
        priceId,
        quantity: data.quantity,
        amount: data.amount,
        type: data.type,
        email: this.value.email ? this.value.email : this.user.email,
        plan: data.plan,
        storage: data.storage,
        coupon: this.value.coupon ? this.value.coupon : "",
        planSelected: data.planSelected,
        info: data.info,
      };
      api
        .post(`/create-subscription/${this.$route.params.account_id}`, {
          encrypt: { data: payload },
        })
        .then((data) => {
          const { latest_invoice } = data.data.encrypt.success;
          const { payment_intent } = latest_invoice;
          if (payment_intent) {
            const { client_secret, status } = payment_intent;
            if (status === "requires_action") {
              self.handleActionRequires(client_secret);
            } else {
              if (status == "succeeded") {
                self.checkData();
              }
            }
          } else if (
            latest_invoice &&
            latest_invoice.discount &&
            latest_invoice.discount.coupon &&
            latest_invoice.discount.coupon.id
          ) {
            self.checkData();
          }
        })
        .catch((err) => {
          this.showSpinner = false;
          if (err.response && err.response.status == 402)
            self.$toaster.error(err.response.data.message);
          else {
            console.log({ err });
            self.$toaster.error("Something went wrong..Please try again.!");
          }
        });
    },
    sendEmail(emailPayload) {
      api
        .post("/payment/email", {
          encrypt: { data: emailPayload },
        })
        .then((data) => {
          console.log(data);
        })
        .catch((err) => {
          console.log("Fail to send confirm email", { err });
        });
    },
    checkData() {
      let self = this;
      let count = 0;
      let timeInterval = setInterval(() => {
        this.$store
          .dispatch("accountPlans/getAccountPlanFeatures")
          .then((data) => {
            let plan = data.plan;
            if (plan.toLowerCase() == this.plan.toLowerCase() && count == 0) {
              count++;
              clearInterval(timeInterval);
              let payload = {
                account: self.$route.params.account_id,
                users: self.sliderValue,
                storage: self.storage,
                plan: self.planId,
              };
              let emailPayload = {
                account: self.$route.params.account_id,
                type: self.planSelected,
                plan: self.plan,
                email: self.user.email,
                users: self.sliderValue,
              };
              api
                .post(`/add/users/storage`, { encrypt: { data: payload } })
                .then((data) => {})
                .catch((err) => {
                  console.log({ err });
                });
              self.sendEmail(emailPayload);
              let toasterMessage =
                this.plan == "pi"
                  ? "Congratulations! You are a Portfolio Insider user now!!"
                  : "Congratulations! You are a Angel Pro user now!!";

              self.$toaster.success(toasterMessage);
              self.handleCancel();
              self.$router.push(`/${self.$route.params.account_id}/workspace`);
            }
          });
      }, 1000);
      // window.setTimeout(() => {}, 4000);
    },
    handleActionRequires(client_secret) {
      let self = this;
      return this.stripe
        .confirmCardPayment(client_secret, {
          setup_future_usage: "off_session",
        })
        .then((data) => {
          self.checkData();
        })
        .catch((err) => {
          self.showSpinner = false;
          console.log({ err });
          self.$toaster.error("Something went wrong..Please try again.!");
        });
    },
    applyPromoCode() {
      if (this.value.coupon && this.value.coupon.length > 0) {
        this.validPromoCode = false;
        this.inValidPromoCode = false;
        this.showLoader = true;
        this.isDisabled = true;
        api
          .get("/list/coupons")
          .then((data) => {
            let list = data.data.success.data;
            let coupon = list.find((item) => {
              if (item.id === this.value.coupon && item.valid) return item;
            });
            if (coupon && coupon.id) {
              if (coupon.amount_off) {
                let remainingValue = this.btnAmount - coupon.amount_off;
                this.btnAmount = remainingValue > 0 ? remainingValue : 0;
                this.validPromoCode = true;
                this.inValidPromoCode = false;
                this.showLoader = false;
                this.isDisabled = false;
              }
              if (coupon.percent_off) {
                let remainingValue =
                  this.btnAmount - (this.btnAmount * coupon.percent_off) / 100;
                this.btnAmount = remainingValue > 0 ? remainingValue : 0;
                this.validPromoCode = true;
                this.inValidPromoCode = false;
                this.showLoader = false;
                this.isDisabled = false;
              }
            } else {
              this.validPromoCode = false;
              this.inValidPromoCode = true;
              this.showLoader = false;
              this.isDisabled = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$toaster.error("Promocode cannot be empty.");
      }
    },
  },
};
</script>
<style>
.paymentsTopbar {
  height: 156px;
  background: #5446f3 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  opacity: 1;
}

.fiifiPaymentTitle {
  text-align: center;
  font-size: 24px;
  line-height: 29px;
  font-family: "custom-helvetica-bold", "roboto";
  letter-spacing: 0px;
  color: #ffffff;
}

.paymentPlanTitle {
  text-align: center;
  font-size: 41px;
  line-height: 49px;
  font-family: "custom-helvetica", "roboto";
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.userNumberdiv {
  text-align: center;
  font-size: 24px;
  line-height: 29px;
  font-family: "custom-helvetica-medium", "roboto";
  letter-spacing: 0px;
  color: #5d5d5d;
  opacity: 1;
}

.paymentsPageMainLayout {
  min-height: 100vh;
  height: auto;
  background-color: #f9f9f9;
}

.slider {
  /* overwrite slider styles */
  width: 307px;
}

.range-slider-knob {
  height: 32px;
  width: 32px;
  background: #5446f3 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 3px solid #ffffff;
}

.range-slider-rail,
.range-slider-fill {
  height: 15px;
  border-radius: 8px;
}

.range-slider-fill {
  background-color: #e2e2e2;
}

.paymentCard {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  height: 177px;
  width: 177px;
}

.paymentDollar {
  text-align: center;
  font-size: 36px;
  line-height: 27px;
  font-family: "custom-helvetica-bold", "roboto";
  letter-spacing: 0px;
  color: #000000;
}

.paymentMO {
  text-align: center;
  font-size: 22px;
  line-height: 27px;
  font-family: "custom-helvetica", "roboto";
  letter-spacing: 0px;
  color: #000000;
  margin-top: 10px;
}

.paymentPayMonthly {
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  font-family: "custom-helvetica", "roboto";
  letter-spacing: 0px;
  color: #8d8d8d;
  opacity: 1;
}

.paymentSaving {
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  font-family: "custom-helvetica", "roboto";
  letter-spacing: 0px;
  color: #ffce00;
  opacity: 1;
}

.paymentContinueString {
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  font-family: "custom-helvetica-medium", "roboto";
  letter-spacing: 0px;
  color: #575757;
  opacity: 1;
}

.continueToPaymentButton {
  background: #ff9300 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  width: 209px;
  height: 40px;
}

.continueToPaymentButtonString {
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  font-family: "custom-helvetica-medium", "roboto";
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin-top: 12px;
}

.paymentCard:hover {
  cursor: pointer;
}

.continueToPaymentButton:hover {
  cursor: pointer;
}

.paymentModal .el-dialog {
  height: 785px;
  width: 539px;
}

.promocodeMainDiv {
  border-radius: 4px;
  border: 1px solid #868686;
  margin-top: 4px;
  margin-bottom: 10px;
  height: 40px;
  overflow: hidden;
}

.promocodeTextFieldDiv {
  background-color: #ffffff;
  font-size: 0.875rem;
  padding: 8px 12px;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 90%;
}

.applyPromocodeTextMainDiv {
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}

.applyPromocodeTextMainDiv:hover {
  text-decoration: underline;
}

.promocodeInputTypeText {
  border: 0;
  color: #565656;
  width: 100%;
}
</style>
